import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";

export default function SignInRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:userSignInId'} element={<Detail {...props} />} />
        </Routes>
    </>
}